

import { type ComponentProps, forwardRef, useId } from 'react';

import { css, cx } from '@/styled-system/css';

import { spinnerFillStyle } from './styles/spinner.styles';

/**
 * This needs to be a separate component to mirror constellation-icon children structure in order to work with <Icon />
 */

export const IconSpinner = forwardRef<SVGSVGElement, ComponentProps<'svg'>>(
  (props, forwardedRef) => {
    const { children, ...rest } = props;
    const id = useId();

    return (
      <svg viewBox="0 0 44 44" ref={forwardedRef} {...rest}>
        {children}
        <clipPath id={`${id}_clip`}>
          <path d="M22 44C31.5789 44 39.728 37.8781 42.7482 29.3333H34.7045C32.1686 33.7172 27.4287 36.6667 22 36.6667C13.8998 36.6667 7.33333 30.1002 7.33333 22C7.33333 13.8998 13.8998 7.33333 22 7.33333C30.1002 7.33333 36.6667 13.8998 36.6667 22C36.6667 24.025 38.3083 25.6667 40.3333 25.6667C42.3584 25.6667 44 24.025 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z" />
        </clipPath>
        <foreignObject width="44" height="44" clipPath={`url(#${id}_clip)`}>
          <div className={cx('c11n', css(spinnerFillStyle))} />
        </foreignObject>
      </svg>
    );
  },
);

IconSpinner.displayName = 'IconSpinner';
